import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const ContactFormSection = ({ 
  formData, 
  errors, 
  onChange 
}) => {
  const formTypeOptions = [
    { value: 'email', label: 'Email уведомления' },
    { value: 'telegram', label: 'Telegram бот' },
    { value: 'webhook', label: 'Webhook URL' }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg md:text-xl font-semibold text-foreground mb-4">
          Форма обратной связи
        </h3>
        <p className="text-sm text-text-secondary mb-6">
          Настройте получение заявок с сайта
        </p>
      </div>
      <Checkbox
        label="Включить форму обратной связи"
        checked={formData?.enableContactForm}
        onChange={(e) => onChange({ 
          target: { name: 'enableContactForm', value: e?.target?.checked } 
        })}
        description="Показывать форму на страницах сайта"
        className="mb-6"
      />
      {formData?.enableContactForm && (
        <div className="space-y-6 pl-0 md:pl-8">
          <Select
            label="Способ получения заявок"
            options={formTypeOptions}
            value={formData?.contactFormType}
            onChange={(value) => onChange({ 
              target: { name: 'contactFormType', value } 
            })}
            error={errors?.contactFormType}
            description="Куда отправлять заполненные формы"
            className="mb-4"
          />

          {formData?.contactFormType === 'email' && (
            <Input
              label="Email для уведомлений"
              type="email"
              name="notificationEmail"
              placeholder="notifications@example.ru"
              value={formData?.notificationEmail}
              onChange={onChange}
              error={errors?.notificationEmail}
              required
              description="На этот адрес будут приходить заявки"
            />
          )}

          {formData?.contactFormType === 'telegram' && (
            <div className="space-y-4">
              <Input
                label="Telegram Bot Token"
                type="text"
                name="telegramBotToken"
                placeholder="1234567890:ABCdefGHIjklMNOpqrsTUVwxyz"
                value={formData?.telegramBotToken}
                onChange={onChange}
                error={errors?.telegramBotToken}
                required
                description="Получите токен у @BotFather"
              />
              <Input
                label="Telegram Chat ID"
                type="text"
                name="telegramChatId"
                placeholder="-1001234567890"
                value={formData?.telegramChatId}
                onChange={onChange}
                error={errors?.telegramChatId}
                required
                description="ID чата или канала для уведомлений"
              />
            </div>
          )}

          {formData?.contactFormType === 'webhook' && (
            <Input
              label="Webhook URL"
              type="url"
              name="webhookUrl"
              placeholder="https://example.com/webhook"
              value={formData?.webhookUrl}
              onChange={onChange}
              error={errors?.webhookUrl}
              required
              description="POST запрос с данными формы"
            />
          )}

          <div className="border-t border-border pt-6">
            <h4 className="text-base font-semibold text-foreground mb-4">
              Поля формы
            </h4>
            
            <div className="space-y-3">
              <Checkbox
                label="Имя"
                checked={formData?.formFields?.name}
                onChange={(e) => onChange({ 
                  target: { 
                    name: 'formFields', 
                    value: { ...formData?.formFields, name: e?.target?.checked } 
                  } 
                })}
              />
              <Checkbox
                label="Телефон"
                checked={formData?.formFields?.phone}
                onChange={(e) => onChange({ 
                  target: { 
                    name: 'formFields', 
                    value: { ...formData?.formFields, phone: e?.target?.checked } 
                  } 
                })}
              />
              <Checkbox
                label="Email"
                checked={formData?.formFields?.email}
                onChange={(e) => onChange({ 
                  target: { 
                    name: 'formFields', 
                    value: { ...formData?.formFields, email: e?.target?.checked } 
                  } 
                })}
              />
              <Checkbox
                label="Сообщение"
                checked={formData?.formFields?.message}
                onChange={(e) => onChange({ 
                  target: { 
                    name: 'formFields', 
                    value: { ...formData?.formFields, message: e?.target?.checked } 
                  } 
                })}
              />
            </div>
          </div>

          <div className="bg-accent/10 p-4 rounded-lg flex items-start gap-3">
            <Icon name="Shield" size={20} className="text-accent flex-shrink-0 mt-0.5" />
            <div className="space-y-1">
              <p className="text-sm font-medium text-foreground">Защита от спама</p>
              <p className="text-xs md:text-sm text-text-secondary">
                Все формы автоматически защищены от спам-ботов с помощью Google reCAPTCHA v3
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactFormSection;